import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import { en } from './en';

export const knbrOrderToolsTranslations: TranslationResources = { en };

export const knbrOrderToolsTranslationChunksConfig: TranslationChunksConfig = {
  knbrOrderTools: ['orderImport', 'quickEntry', 'quickOrder', 'knbrOrderDetails', 'orderForms', 'button'],
};
